export default "__VITE_ASSET__58c30c83__"